export const ORDER_PARAM = 'order';
export const PRICE_DESC = '_price_desc';
export const PRICE_ASC = '_price_asc';
export const BEST_PRICE = 'melhor-preco';
export const LOWEST_PRICE = 'menor-preco';
